import { AppStatus } from '@/redux'
import { APIClient } from '@/services'
import { PulseStore } from '../store'
import { useAuthState } from '@/features/Auth/bridge/useAuthState'

export function usePulseQuestions() {
  const { isLoggedIn } = useAuthState()
  const ids = PulseStore.use(s => s.initialQuestions)
  const from = PulseStore.use(s => s.from)

  const query = APIClient.Pulse.usePulseQuestionsQuery(ids, isLoggedIn)
  const questions = query.data?.questions ?? []

  const invalidateQuestions = async (withLoading = true) => {
    if (withLoading) {
      AppStatus.set('loading')
    }

    await query.refetch()

    if (withLoading) {
      AppStatus.set('idle')
    }
  }

  const available = query.isFetched && questions.length > 0

  return {
    query,
    questions,
    available,
    from,
    invalidateQuestions
  }
}
